// extracted by mini-css-extract-plugin
module.exports = {"popover":"M5TVw","top":"S9Rai","inner":"cShDO","right":"im8mC","bottom":"jGfxu","left":"HKJdD","content":"JfOKk"};